export default __webpack_public_path__ + "static/media/14.992bc8e9.jpg";